<template>
  <article class="page">
    <div class="flex">
      <div class="flex flex-col lg:mr-5 xl:w-3/4 2xl:w-4/5">
        <h1
          class="mb-[28px] text-[32px] font-medium leading-[38px]"
          v-text="testSlug?.data?.value?.title"
        />
        <CommonBlocksImageArticleBlock
          v-if="testSlug?.data?.value?.image"
          class="mb-[32px]"
          is-social
          :data="testSlug?.data?.value"
          :published-at="testSlug?.data?.value?.published_at"
          :src="testSlug?.data?.value?.image.src"
        />
        <div class="text-[18px] leading-[28px]">
          <div v-html="testSlug?.data?.value?.description"></div>
        </div>
        <div v-if="isDesktop">
          <template v-if="testState === 'ready'">
            <div class="mt-14 flex">
              <div class="w-full md:w-1/3">
                <BaseTheButtonNew
                  text="Пройти тест"
                  type="secondary"
                  @click="handleStartTest"
                />
              </div>
            </div>
          </template>
          <template v-else-if="isTestInProgress">
            <div class="mt-14 flex">
              <div class="w-full md:w-1/3">
                <BaseTheButtonNew
                  text="Завершить тест"
                  type="default"
                  @click="testState = 'finished'"
                />
              </div>
            </div>
          </template>
          <template v-else-if="testState === 'finished'">
            <div class="flex">
              <div class="w-full md:w-1/3">
                <BaseTheButtonNew
                  text="Пройти заново"
                  class="mt-14"
                  @click="handleResetTest"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
      <CommonBlocksRightArticleBlock
        class="xl:w-1/4 2xl:w-1/5"
        articles-per-page="3"
      />
    </div>

    <div ref="test_wrapperRef" class="mt-9 flex flex-col xl:flex-row">
      <template
        v-if="
          isTestInProgress ||
          (isNotDesktop && ['ready', 'proceed'].includes(testState))
        "
      >
        <div
          class="flex flex-col rounded-[12px] bg-white-100 p-4 pb-5 shadow-drop-0 xl:mr-5 xl:w-3/4 xl:px-12 xl:pb-12 xl:pt-13 2xl:w-4/5"
          :class="{ 'mask-mob': testState === 'ready' }"
        >
          <div class="flex flex-col">
            <div
              v-if="getCurrentQuestion?.image"
              class="mb-12 mr-8 h-[364px] w-full max-w-[548px] overflow-hidden rounded-xl"
            >
              <img
                v-lazy-load="
                  getCurrentQuestion?.image || '/imgs/default-image.png'
                "
                alt=""
                class="h-inherit w-full object-cover"
              />
            </div>
            <div
              class="mb-[24px] flex-1 whitespace-pre-wrap text-[16px] font-bold leading-[20px] text-new-test-black lg:leading-[34px] xl:mb-[44px] xl:text-[24px]"
              v-html="getCurrentQuestion?.text"
            ></div>
          </div>
          <div
            class="flex flex-col pl-1 xl:flex-row xl:flex-wrap xl:pl-[initial]"
          >
            <TestsAnswerOptionButton
              v-for="(answer, idx) in getCurrentQuestion?.answer"
              :key="`test-answer-${answer.id}`"
              v-model:currently-checked-id="currentAnswerId"
              :data="answer"
              :update-question-answered="
                getUpdateCurrentQuestion?.count_answered
              "
              :count-question-answer="
                getUpdateCurrentQuestion?.answer?.[idx].count_answered
              "
              :disabled="!!currentAnswerId || testState === 'finished'"
              class="my-1.5 xl:mb-6"
              :class="{
                'lg:w-1/2': testSlug?.data?.value?.view_type === 1,
                'lg:w-full': testSlug?.data?.value?.view_type === 2,
              }"
              @update-count-answer="
                handleCountAnswers(getCurrentQuestion.id, answer.id)
              "
            />
          </div>
          <div class="mt-auto flex justify-between">
            <BaseTheButtonNew
              v-if="(!!currentAnswerId || isNotDesktop) && !isLastQuestion"
              class="mr-5 mt-1.5 xl:mt-auto"
              text="Следующий вопрос"
              type="default"
              :icon="!isNotDesktop ? 'arrow-right-circle' : ''"
              is-small
              :disabled="
                (!isNotDesktop && !!isLastQuestion) ||
                (isNotDesktop && testState === 'finished')
              "
              @click="handleNextQuestion(false)"
            />
            <BaseTheButtonNew
              class="mt-1.5 xl:hidden"
              type="secondary--disabled"
              text="пропустить"
              is-small
              disabled
            />
          </div>

          <div class="mt-6 border-t border-[#F3F3F3] pt-5 xl:hidden">
            <TestsTestProgressBlock
              v-if="isNotDesktop"
              :question="{
                current: currentQuestionIndex,
                total: questions.length,
              }"
              :test-state="testState"
              :total-test-time="testSlug?.data?.value?.time"
              @time-is-left="handleNextQuestion(true)"
            />
          </div>
        </div>
        <!-- <div v-if="getCurrentQuestion.image">
            <img :src="getCurrentQuestion.image.src" alt="" />
          </div> -->
      </template>

      <template v-else-if="testState === 'finished'">
        <div
          class="flex flex-col rounded-[12px] bg-white-100 p-4 pb-5 shadow-drop-0 xl:mr-5 xl:w-3/4 xl:px-12 xl:pb-12 xl:pt-13 2xl:w-4/5"
        >
          <div>
            <div class="text-heading-h4 xl:mb-[106px]">
              <p>{{ testResults.title }}</p>
              <p>{{ testResults.text }}</p>
            </div>
            <template v-if="Object.keys(testResults)?.length">
              <div
                v-if="!isSuccessTest"
                class="mx-auto my-[12vh] flex w-fit items-center text-ruby-red-100 xl:my-[initial]"
              >
                <SvgIcon
                  name="failed-filled"
                  width="64"
                  height="64"
                  class="icon-reset"
                />
                <span class="ml-5 text-[24px] font-bold">Тест не пройден</span>
              </div>
              <div
                v-else
                class="mx-auto my-[12vh] flex w-fit items-center text-correct xl:my-[initial]"
              >
                <SvgIcon
                  name="success-filled"
                  width="64"
                  height="64"
                  class="icon-reset"
                />
                <span class="ml-5 text-[24px] font-bold">Успех!</span>
              </div>
            </template>
          </div>
          <div class="mt-auto flex justify-between">
            <BaseTheButtonNew
              v-if="
                (!!currentAnswerId || isNotDesktop) && testState !== 'finished'
              "
              class="mt-1.5 lg:mt-auto"
              text="Следующий вопрос"
              type="default"
              :icon="!isNotDesktop ? 'arrow-right-circle' : ''"
              is-small
              :disabled="
                (!isNotDesktop && !!isLastQuestion) ||
                (isNotDesktop && testState === 'finished')
              "
              @click="handleNextQuestion(false)"
            />
            <BaseTheButtonNew
              class="mt-1.5 xl:hidden"
              type="secondary--disabled"
              text="пропустить"
              is-small
              disabled
            />
          </div>
        </div>
      </template>

      <div v-if="isNotDesktop">
        <template v-if="testState === 'ready'">
          <div class="mt-4 flex xl:mt-14">
            <div class="w-full xl:w-1/3">
              <BaseTheButtonNew
                class="mx-auto"
                text="Пройти тест"
                type="secondary"
                @click="handleStartTest"
              />
            </div>
          </div>
        </template>
        <template v-else-if="isTestInProgress">
          <div class="mt-4 flex xl:mt-14">
            <div class="w-full xl:w-1/3">
              <BaseTheButtonNew
                key="default"
                class="mx-auto"
                text="Завершить тест"
                type="default"
                @click="(testState = 'finished'), loadResults()"
              />
            </div>
          </div>
        </template>
        <template v-else-if="testState === 'finished'">
          <div class="flex">
            <div class="mt-4 w-full xl:mt-14 xl:w-1/3">
              <BaseTheButtonNew
                class="mx-auto"
                text="Пройти заново"
                @click="handleResetTest"
              />
            </div>
          </div>
        </template>
      </div>

      <div
        v-if="testState !== 'ready' && isNotMobile"
        class="col-span-3 col-start-10 hidden h-full xl:block xl:w-1/4 2xl:w-1/5"
      >
        <div class="rounded-[12px] bg-white-100 px-6 pb-11 pt-7 shadow-drop-0">
          <TestsTestProgressBlock
            v-if="!isNotDesktop"
            :question="{
              current: currentQuestionIndex,
              total: questions.length,
              isSuccessTest: isSuccessTest,
            }"
            :test-state="testState"
            :total-test-time="testSlug?.data?.value?.time"
            :current-answer-id="currentAnswerId"
            @time-is-left="handleNextQuestion(true)"
            @on-miss-question-click="handleNextQuestion(false)"
            @handle-reset-test="handleResetTest()"
          />
        </div>
      </div>
    </div>
    <!-- <section class="section mb-32">
      <CommonCommentsBlock
        :comments="testSlug?.data?.value?.comments"
        :model-type="testSlug?.data?.value?.model_type"
        :model-id="testSlug?.data?.value?.id"
      />
    </section> -->
    <CommonBlocksPageFooterBlocks />
  </article>
</template>

<script setup>
import api from '@/services/api/api';

definePageMeta({
  layout: 'marginless',
});

const { isNotMobile, isDesktop, isNotDesktop } = useBreakpoint();
const route = useRoute();
const slug = route?.params?.slug;
const { testSlug } = useTestBySlug(slug);

// const comments = ref([]);
// const seo = ref({});
// const robots = ref('all');
const testState = ref('ready');
const currentQuestionIndex = ref(0);
const currentAnswerId = ref(null);
const goResult = ref(false);
const rightAnswers = ref(0);
const points = ref(0);
const testResults = ref({});
// const categories = ref([]);
const getUpdateCurrentQuestion = ref({});
const test_wrapperRef = ref(null);

const questions = computed(() => testSlug?.data?.value?.questions || []);

const getCurrentQuestion = computed(() => {
  return questions.value[currentQuestionIndex.value];
});

const getCurrentAnswer = computed(() => {
  return getCurrentQuestion.value?.answer?.find(
    (el) => el.id === currentAnswerId.value,
  );
});

const isLastQuestion = computed(() => {
  return currentQuestionIndex.value === questions.value?.length - 1;
});

const isTestInProgress = computed(() => {
  return testState.value === 'proceed';
});

// const questionsCount = computed(() => {
//   return questions.value?.length;
// });

const isSuccessTest = computed(() => {
  return testResults.value?.lowest_value > 0;
});

watch(currentAnswerId, (newValue, oldValue) => {
  if (newValue && !oldValue) {
    if (getCurrentAnswer.value?.is_right) {
      rightAnswers.value++;
      if (getCurrentAnswer.value?.points) {
        points.value += getCurrentAnswer.value.points;
      }
    }

    if (!!isLastQuestion.value && !!currentAnswerId.value) {
      goResult.value = true;
    }
  }
});

/** methods */
// const finishedTest = () => {
//   testState.value = 'finished';
//   loadResults();
// };

const handleNextQuestion = (isTimeLeft = false) => {
  if (isLastQuestion.value || isTimeLeft) {
    testState.value = 'finished';
    loadResults();
  } else {
    currentAnswerId.value = null;
    currentQuestionIndex.value++;
  }
  const top =
    window.scrollY + test_wrapperRef.value.getBoundingClientRect().y - 184; // 184 - отступ header + кнопка
  window.scroll(0, top);
};

const handleResetTest = () => {
  testState.value = 'ready';
  currentQuestionIndex.value = 0;
  currentAnswerId.value = null;
  rightAnswers.value = 0;
  points.value = 0;
  window.scroll(0, 0);
};

const handleStartTest = () => {
  testState.value = 'proceed';
  const top =
    window.scrollY + test_wrapperRef.value.getBoundingClientRect().y - 184; // 184 - отступ header + кнопка
  window.scroll(0, top);
};

const handleCountAnswers = async (questionId, answerId) => {
  try {
    const { data } = await api.tests.updateCountAnswers(questionId, answerId);
    getUpdateCurrentQuestion.value = data.data;
  } catch (e) {
    console.log(e);
  }
};

const loadResults = async () => {
  const testId = route.params.slug;
  const testStats = {
    count: rightAnswers.value,
    points: points.value,
  };

  try {
    const { data } = await api.tests.loadTestResults(testId, testStats);
    testResults.value = data;
  } catch (e) {
    console.log(e);
  }
};

/*
import TheButtonNew from '@/components/Base/TheButtonNew';
import ImageArticleBlock from '@/components/Common/Blocks/ImageArticleBlock';
import PageFooterBlocks from '@/components/Common/Blocks/PageFooterBlocks';
import RightArticleBlock from '@/components/Common/Blocks/RightArticleBlock';
import CommentsBlock from '@/components/Common/Comments/CommentsBlock';
import AnswerOptionButton from '@/components/Tests/AnswerOptionButton';
import TestProgressBlock from '@/components/Tests/TestProgressBlock';
// import AnswerCheckBlock from '@/components/Tests/AnswerCheckBlock'
import getCountEnding from '@/mixins/getCountEnding';
import getScreenBreakpoint from '@/mixins/getScreenBreakpoint';
import api from '@/services/api/api';

export default {
  components: {
    CommentsBlock,
    PageFooterBlocks,
    TestProgressBlock,
    AnswerOptionButton,
    // AnswerCheckBlock,
    ImageArticleBlock,
    RightArticleBlock,
    TheButtonNew,
  },
  mixins: [getCountEnding, getScreenBreakpoint],

  layout: 'marginless',

  async asyncData({ route, error }) {
    try {
      const slug = route.params.slug;

      const { data } = await api.tests.getTestBySlug(slug);

      let robots;
      if (data.seo) {
        const arr = [];
        if (data.seo.index === false) arr.push('noindex');
        if (data.seo.follow === false) arr.push('nofollow');
        if (data.seo.archive === false) arr.push('noarchive');
        if (arr.length > 0) {
          robots = arr.reduce((previousValue, currentValue) => {
            return `${previousValue}, ${currentValue}`;
          });
        }
      }

      return {
        testData: data?.data,
        questions: data?.data?.questions,
        comments: data?.data?.comments,
        seo: data?.data?.seo ?? {},
        robots: robots ?? 'all',
        categories: data?.data?.categories,
      };
    } catch (e) {
      console.log(e);
      error({ statusCode: e.response?.status ?? 503 });
    }
  },

  data() {
    return {
      testData: {},
      questions: [],
      comments: [],
      seo: {},
      robots: 'all',
      testState: 'ready',
      currentQuestionIndex: 0,
      currentAnswerId: null,
      goResult: false,
      rightAnswers: 0,
      points: 0,
      testResults: {},
      categories: [],
      getUpdateCurrentQuestion: {},
    };
  },

  head() {
    return {
      title: `${this.testData.title} | Тесты по истории РФ для школьников и студентов`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `${this.testData.title}. Тесты по истории РФ для школьников и студентов на сайте Федерального портала истории России.`,
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: `${this.testData.title}`,
        },
        {
          'http-equiv': 'Last-Modified',
          content: new Date(this.seo?.last_modified).toUTCString(),
        },
        {
          hid: 'robots',
          name: 'robots',
          content: this.robots,
        },
      ],
    };
  },

  computed: {
    getCurrentQuestion() {
      return this.questions[this.currentQuestionIndex];
    },

    getCurrentAnswer() {
      return this.getCurrentQuestion?.answer?.find(
        (el) => el.id === this.currentAnswerId,
      );
    },

    isLastQuestion() {
      return this.currentQuestionIndex === this.questions.length - 1;
    },

    isTestInProgress() {
      return this.testState === 'proceed';
    },

    questionsCount() {
      return this.questions.length;
    },

    isSuccessTest() {
      return this.testResults?.lowest_value > 0;
    },
  },

  watch: {
    currentAnswerId(newValue, oldValue) {
      if (newValue && !oldValue) {
        if (this.getCurrentAnswer.is_right) {
          this.rightAnswers++;
          if (this.getCurrentAnswer.points) {
            this.points += this.getCurrentAnswer.points;
          }
        }

        if (!!this.isLastQuestion && !!this.currentAnswerId) {
          this.goResult = true;
        }
      }
    },
  },

  methods: {
    finishedTest() {
      this.testState = 'finished';
      this.loadResults();
    },

    handleNextQuestion(isTimeLeft = false) {
      if (this.isLastQuestion || isTimeLeft) {
        this.testState = 'finished';
        this.loadResults();
      } else {
        this.currentAnswerId = null;
        this.currentQuestionIndex++;
      }
      const top =
        window.scrollY +
        this.$refs.test_wrapper.getBoundingClientRect().y -
        184; // 184 - отступ header + кнопка
      window.scroll(0, top);
    },

    handleResetTest() {
      this.testState = 'ready';
      this.currentQuestionIndex = 0;
      this.currentAnswerId = null;
      this.rightAnswers = 0;
      this.points = 0;
      window.scroll(0, 0);
    },

    handleStartTest() {
      this.testState = 'proceed';
      const top =
        window.scrollY +
        this.$refs.test_wrapper.getBoundingClientRect().y -
        184; // 184 - отступ header + кнопка
      window.scroll(0, top);
    },

    async handleCountAnswers(questionId, answerId) {
      try {
        const { data } = await api.tests.updateCountAnswers(
          questionId,
          answerId,
        );
        this.getUpdateCurrentQuestion = data.data;
      } catch (e) {
        console.log(e);
      }
    },

    async loadResults() {
      const testId = this.$route.params.slug;
      const testStats = {
        count: this.rightAnswers,
        points: this.points,
      };

      try {
        const { data } = await api.tests.loadTestResults(testId, testStats);
        this.testResults = data;
      } catch (e) {
        console.log(e);
      }
    },
  },
};*/
</script>

<style lang="scss">
.mask-mob {
  @apply relative;
  @apply before:absolute before:inset-0 before:bg-[#ffffff7a] before:z-10 pointer-events-none;
}
</style>
